import { Divider, Grid, Paper, Typography } from "@mui/material";
import * as React from "react";

import textBoxData from "../data/dashboard_dummy/textBox_data.json";
import { Chart, defaults } from "chart.js/auto";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import dateWiseRequestData from "../data/dashboard_dummy/dateWiseRequest_data.json";
import topModels from "../data/dashboard_dummy/topModels.json";
import type { ChartData, ChartOptions } from "chart.js";
import DashboardButton from "./DashboardButton";

import colors from "../data/brandColors";
import apiCall from "../utils/apiCall";
import { GET_DASHBOARD } from "../endpoint";
import { useAppDispatch } from "../hooks/reduxhook";
import { addError } from "../redux/slices/errorSlice";

defaults.maintainAspectRatio = false;
defaults.responsive = true;
defaults.plugins.title.display = true;
defaults.plugins.title.align = "start";

interface LineProps {
  options: ChartOptions<"line">;
  data: ChartData<"line">;
}

// Controlling grids of charts
const DISPLAY = false;
const BORDER = true;
const CHART_AREA = true;
const TICKS = true;

const Dashboard: React.FunctionComponent = () => {
  let totalRequests = 0;
  let totalCosts = 0;
  let totalLatency = 0;
  const dispatch = useAppDispatch();
  const set = new Set();
  dateWiseRequestData.map((data) => {
    set.add(data.date);
    totalRequests += data.requests;
    totalCosts += Number(data.cost);
    totalLatency += data.latency;
  });

  const labels_array: any[] = [];
  set.forEach((e) => labels_array.push(e));

  const dateWiseRequest_data = {
    labels: labels_array,
    datasets: [
      {
        label: "gpt-4-32k",
        data: dateWiseRequestData
          .filter((data) => data.response_type === 200)
          .map(({ requests }) => requests),
        backgroundColor: colors[0],
        borderColor: colors[0],
      },
      {
        label: "gpt-35-turbo",
        data: dateWiseRequestData
          .filter((data) => data.response_type === 400)
          .map(({ requests }) => requests),
        backgroundColor: colors[1],
        borderColor: colors[1],
      },
    ],
  };

  const topModels_data = {
    labels: topModels.map((data) => data.name),
    datasets: [
      {
        label: "Requests",
        data: topModels.map((data) => data.requests),
        backgroundColor: [
          "rgb(245, 174, 69)",
          "rgb(0, 173, 198)",
          "rgb(107, 191, 188)",
          "rgb(255, 131, 114)",
          "rgb(158, 204, 122)",
          "rgb(107, 191, 207)",
          "rgb(35, 30, 40)",
          "rgb(238, 238, 238)",
          "rgb(253, 95, 7)",
          "rgb(77, 77, 77)",
        ],
      },
    ],
  };

  const costData = {
    labels: labels_array,
    datasets: [
      {
        label: "cost",
        data: dateWiseRequestData.map((data) => data.cost),
      },
    ],
  };

  const latencyData = {
    labels: labels_array,
    datasets: [
      {
        label: "latency",
        data: dateWiseRequestData.map((data) => data.latency),
      },
    ],
  };

  React.useEffect(() => {
    const fetchDashBoard = () => {
      apiCall("GET", GET_DASHBOARD)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          dispatch(addError("Failed to load the data. Please try again."));
        });
    };
    fetchDashBoard();
  }, []);

  return (
    <Grid container my={1} direction="column">
      <Divider
        sx={{
          mb: 2,
        }}
      >
        <Typography fontWeight="bolder">Average Per Request</Typography>
      </Divider>
      <Grid container item spacing={2}>
        {textBoxData.map(({ heading, value }, i) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={heading}>
            <DashboardButton
              title={heading}
              value={value}
              marginRight={i === textBoxData.length - 1 ? 0 : 5}
            />
          </Grid>
        ))}
      </Grid>
      <Divider
        sx={{
          my: 1,
        }}
      />
      <Grid container item mt={3} spacing={2}>
        <Grid item xs={12} sm={6}>
          <DashboardButton
            title="Most used model"
            value="gpt-35-turbo"
            marginRight={5}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DashboardButton
            title="Most Active Time"
            value="3:00pm"
            marginRight={0}
          />
        </Grid>
      </Grid>

      <Paper
        sx={{
          p: 2,
          width: "100%",
          height: "250px",
          mt: 3,
        }}
      >
        {/* Uncomment and configure the Line chart as needed */}
        {/* <Line
          data={dateWiseRequest_data}
          options={{
            borderWidth: "2",
            pointRadius: 2,
            stacked: true,
            plugins: {
              title: {
                text: "Costs this week",
                color: "rgb(77, 77, 77)",
                font: {
                  family: "poppins",
                  size: 16,
                },
              },
            },
            scales: {
              x: {
                border: {
                  display: BORDER,
                },
                grid: {
                  display: DISPLAY,
                  drawOnChartArea: CHART_AREA,
                  drawTicks: TICKS,
                },
              },

              y: {
                border: {
                  display: BORDER,
                },
                grid: {
                  display: DISPLAY,
                  drawOnChartArea: CHART_AREA,
                  drawTicks: TICKS,
                },
              },
            },
          }}
        /> */}
      </Paper>
    </Grid>
  );
};

export default Dashboard;